/**
 * Copy of the AMS charts kit (`components/Ams/shared/charts`) — the trend
 * charts' hover card, legend, zoom and summary strip, and the Analytics
 * widgets' plots. Spread into `en.amsView`; owns the `charts` sub-key.
 */
export const amsViewCharts = {
  charts: {
    // Each plot is a keyboard stop; recharts' arrow keys walk its points.
    plot: '{{title}} chart. Use the arrow keys to move between points.',
    scatter: '{{title}} scatter chart',
    bars: '{{title}} bar chart',
    donut: '{{title}} donut chart',
    // The hover card: the bucket, every series, and the change from the one before.
    weekOf: 'Week of {{day}}',
    changeVs: {
      daily: 'Change vs previous day',
      weekly: 'Change vs previous week',
      monthly: 'Change vs previous month',
      quarterly: 'Change vs previous quarter',
      yearly: 'Change vs previous year',
    },
    // The funnel bar's hover card (AmsAnalyticsPanel.tsx:497-503).
    rate: 'Rate',
    // The scatter dots' hover cards, VentaHub's short names (AmsAnalyticsPanel.tsx:373-377, 568-571).
    hover: {
      ctr: 'CTR',
      conversion: 'Conv.',
      spend: 'Spend',
      sales: 'Sales',
    },
    // The legend: each series a toggle.
    legendHint: 'Click to hide or show this series',
    // The zoom bar under a long range.
    zoom: 'Zoom: {{from}} to {{to}}',
    resetZoom: 'Reset zoom',
    // The strip beside the overall chart's picker, for the first picked metric.
    summary: '{{series}} over the range',
    total: 'Total',
    average: {
      daily: 'Daily average',
      weekly: 'Weekly average',
      monthly: 'Monthly average',
      quarterly: 'Quarterly average',
      yearly: 'Yearly average',
    },
    peak: {
      daily: 'Peak day',
      weekly: 'Peak week',
      monthly: 'Peak month',
      quarterly: 'Peak quarter',
      yearly: 'Peak year',
    },
    peakOn: 'on {{period}}',
    loading: 'Loading the chart',
  },
} as const
